export const ZONE_TYPES = {
  addA: 'A',
  addAAA: 'AAAA',
  addCAA: 'CAA',
  addCNAME: 'CNAME',
  addDMARK: 'DMARC',
  addMX: 'MX',
  addSRV: 'SRV',
  addTXT: 'TXT'
}
